<div class="status-legend">
   <button mat-stroked-button *ngFor="let key of SharedKeys"
      (click)="clicked.emit( key )"
      [class.selected]="selected == key">
      <span class="status key" [ngClass]="key"></span> {{SharedKeysEnum[key]}}
   </button>
</div>
